import { TPromisePopupProps } from '@@types/popup';
import { TAddressUpdate } from '@@types/address';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Textarea,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AddressEditModal({
  props,
  closePopup,
}: TPromisePopupProps<TAddressUpdate & { isCurrentAddress: boolean }>) {
  const { t } = useTranslation('common');
  const { register, handleSubmit } = useForm<TAddressUpdate>({
    defaultValues: {
      id: props.id,
      alias: props.alias,
      detail: props.detail,
    },
  });

  const onSubmitValid = (values: TAddressUpdate) => {
    props.resolve(values);
  };

  return (
    <ModalContent>
      <ModalHeader></ModalHeader>
      <form onSubmit={handleSubmit(onSubmitValid)}>
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>{t('address:address_alias')}</FormLabel>
            <Input
              {...register('alias', {
                required: { value: true, message: '' },
              })}
              variant="filled"
            />
          </FormControl>
          <FormControl isRequired>
            <FormLabel>{t('address:detail_address')}</FormLabel>
            <Textarea
              {...register('detail', {
                required: { value: true, message: '' },
              })}
              variant="filled"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <div className="flex items-center gap-[12px] ml-auto">
            <Button onClick={closePopup}>{t('cancel')}</Button>
            <Button className="submit-button" type="submit">
              {t('change')}
            </Button>
          </div>
        </ModalFooter>
      </form>
    </ModalContent>
  );
}
